import styled from "styled-components"

export const EditCommentWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    margin: 0 0 8px 10px;
`
export const EditCommentDescriptionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 52px;
    max-width: calc(100% - 52px);
`
export const NewCommentButton = styled.div`
    display: flex;
    flex-grow: 1;
    margin-left: 12px;
    padding: 8px 16px;
    border-radius: 20px;
    border: 1px solid ${(props) => props.theme.newCommentColor};
    color: ${(props) => props.theme.newCommentColor};
    transition: 0.2s;
    
    &:hover {
        border-color: ${(props) => props.theme.newCommentHoverColor};
        color: ${(props) => props.theme.newCommentHoverColor};
    }
`


export const CommentWrapper = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 30px;
    padding-left: 10px;
`
export const CommentDescriptionWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    margin-left: 12px;
    max-width: calc(100% - 40px - 12px); // 40px - logo width, 12px - margin
    padding: 8px 40px 8px 12px;
    background: ${(props) => props.theme.commentBackgroundColor};
    border-radius: 16px;
`
export const CommentTitleRow = styled.div`
    display: flex;
    flex-direction: row;
`
export const CommentAuthor = styled.div`
    font-size: 13px;
    font-weight: 600;
    margin-right: 20px;
    margin-bottom: 4px;
    border-bottom: 1px dashed ${(props) => props.theme.commentAuthorColor};
    color: ${(props) => props.theme.commentAuthorColor};
`
export const CommentActionWrapper = styled.div`
    position: absolute;
    display: flex;
    flex-direction: row;
    top: 100%;
    left: 20px;
    padding-top: 1px;
    font-size: 13px;
    color: ${(props) => props.theme.commentActionButtonColor};
`
export const CommentAction = styled.div`
    cursor: pointer;
`
